/**
 * L'ABBONAMENTO ALLE LEZIONI LIVE DI UN SINGOLO CLIENTE.
 *
 * Stessa forma di tutte le altre API di v1: fetch, `x-access-token`, `global.checkAuth`
 * sull'esito, promessa che risolve sul risultato buono e rifiuta con la risposta intera.
 *
 * ⚠️ I PIANI NON SONO SCRITTI QUI. Li chiede al server (`plans()`), che li legge da
 * `atom_product_map` — la stessa mappa che usa il ponte quando arriva un incasso da ATOM.
 * Il giorno che GOLD passa da 8 a 10 lezioni, questa schermata lo dice da sola.
 */

const intestazioni = () => ({
    'x-access-token': localStorage.getItem('hash'),
    'Content-Type': 'application/json'
});

/**
 * @param {string|string[]} attesi gli esiti che contano come riuscita.
 *
 * ⚠️ Più di uno serve davvero: `PUT /live/subscription` risponde
 * `LIVE_SUBSCRIPTION_CREATED` o `..._UPDATED` a seconda che la riga ci fosse già. Per chi
 * chiama è la stessa cosa — il cliente ha il piano — e trattarne uno come errore
 * farebbe comparire un messaggio rosso su un salvataggio riuscito.
 */
function chiama(url, opzioni, attesi) {
    const buoni = Array.isArray(attesi) ? attesi : [attesi];

    return new Promise(function (resolve, reject) {
        fetch(url, Object.assign({headers: intestazioni()}, opzioni || {}))
            .then((response) => (response.status !== 500) ? response.json() : reject())
            .then((responseJson) => {
                global.checkAuth(responseJson.status);
                if (buoni.indexOf(responseJson.status) !== -1)
                    resolve(responseJson);
                else
                    reject(responseJson);
            })
            .catch((e) => {
                console.error(e.message);
                reject('APP_ERROR');
            });
    });
}

/** I piani che si possono dare, coi nomi commerciali veri. */
let plans = function () {
    return chiama(global.route.livePlans, {method: 'GET'}, "LIVE_PLANS");
};

/** Che piano ha adesso questo cliente. Risolve con `null` se non ne ha. */
let get = function (idClient) {
    return chiama(global.route.liveSubscriptionClient.replace('{id}', idClient),
        {method: 'GET'}, "LIVE_SUBSCRIPTION")
        .then((r) => r.subscription || null);
};

/**
 * Dà (o cambia) il piano.
 *
 * ⚠️ PUT e non POST: su questo progetto PUT crea, POST modifica — e qui il server fa tutte
 * e due le cose con la stessa rotta, perché di righe live per cliente ne esiste una sola.
 */
let set = function (dati) {
    return chiama(global.route.liveSubscription, {method: 'PUT', body: JSON.stringify(dati)},
        ["LIVE_SUBSCRIPTION_CREATED", "LIVE_SUBSCRIPTION_UPDATED"]);
};

/** Toglie il piano. Non tocca le prenotazioni già fatte. */
let remove = function (idClient) {
    return chiama(global.route.liveSubscriptionClient.replace('{id}', idClient),
        {method: 'DELETE'}, "LIVE_SUBSCRIPTION_DELETED");
};

module.exports = {plans, get, set, remove};
